import request from "./request";

const VMService = {
    startVM: async (vmName, context, signal) => {
        return await request.sendRequest(`/vm/start/${vmName}`, context.token, signal);
    },
    stopVM: async (vmName, context, signal) => {
        return await request.sendRequest(`/vm/stop/${vmName}`, context.token, signal);
    },
    resetVM: async (vmName, context, signal) => {
        return await request.sendRequest(`/vm/reset/${vmName}`, context.token, signal);
    },
    statusVM: async (vmName, context, signal) => {
        return await request.sendRequest(`/vm/status/${vmName}`, context.token, signal);
    },
    getReport: async (id, context, signal) => {
        return await request.sendRequest(`/vmlogin/${id}/report`, context.token, signal);
    },
    getVmUserDetails: async (courseUserId, vmId,  context, signal) => {
        return await request.sendRequest(`/vmlogin/${courseUserId}/${vmId}/details`, context.token, signal);
    },
    
    saveVM: async (payload, context, signal) => {
        return await request.sendPostRequest(`/vm/list`, payload, context, signal);
    },
    getList: async (id, context, signal) => {
        return await request.sendRequest(`/vm/list/${id}`, context.token, signal);
    },
    getVMList: async (id, context, signal) => {
        return await request.sendRequest(`/vm/user/list/${id}`, context.token, signal);
    },
    removeList: async (id, context) => {
        return await request.sendDeleteRequest(`/vm/list/${id}`, context.token);
    },
    getGuacamoleToken: async (context, signal) => {
        return await request.sendRequest(`/vm/guacamole/token`, context.token, signal);
    },
    updateTime: async (vmId, context) => {
       return await request.sendPutRequest(`/vmsessions/${vmId}`, context);
    },
    RemoveSession: async (id, context) => {
        return await request.sendDeleteRequest(`/vmsessions/${id}`, context.token);
    },
};

export default VMService;
